"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({}, props, {
    viewBox: '0 0 10 10',
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-1276.000000, -5342.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(180.000000, 5207.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1011.000000, 128.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(85.000000, 7.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.32644962,6.90527718 C1.27711952,6.85599254 1.20641313,6.83463853 1.13804902,6.84837837 C1.06968492,6.86211822 1.01271908,6.90913185 0.986260793,6.97364846 L0.310052111,8.61580999 C0.2419054,8.78104692 0.229465172,8.96399144 0.274615775,9.13693259 L0.117028302,9.29452006 C-0.0409644838,9.45810206 -0.0387049647,9.71812385 0.122106714,9.87893553 C0.282918393,10.0397472 0.542940179,10.0420067 0.706522183,9.88401394 L0.864109656,9.72642647 C1.03709867,9.77141447 1.22003438,9.75882849 1.38523225,9.69057323 L3.02739378,9.01436455 C3.09168438,8.98776865 3.13846749,8.93085033 3.15211219,8.86262683 C3.16575689,8.79440333 3.14446414,8.72386984 3.09534816,8.67459262 L1.32644962,6.90527718 Z",
    id: "Path"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.69484473,0.8948576 L9.10535084,0.305363719 C8.90988406,0.109845389 8.64474327,0 8.36827504,0 C8.09180682,0 7.82666603,0.109845389 7.63119924,0.305363719 L7.18928728,0.747692579 C7.10791254,0.829091897 7.10791254,0.961040201 7.18928728,1.04243952 L8.95818582,2.81092116 C9.03958514,2.8922959 9.17153345,2.8922959 9.25293276,2.81092116 L9.69484473,2.3685923 C10.1017184,1.96159571 10.1017184,1.30185419 9.69484473,0.8948576 L9.69484473,0.8948576 Z",
    id: "Path"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.79031582,1.44182788 C6.70750103,1.3639461 6.57838368,1.3639461 6.49556888,1.44182788 L1.72583798,6.21239257 C1.64446324,6.29379189 1.64446324,6.4257402 1.72583798,6.50713951 L3.49682101,8.27562116 C3.57822033,8.3569959 3.71016864,8.3569959 3.79156795,8.27562116 L8.55921436,3.50505646 C8.6405891,3.42365714 8.6405891,3.29170884 8.55921436,3.21030952 L6.79031582,1.44182788 Z",
    id: "Path"
  })))))));
});